import vars from '@/styles/vars.icss.scss';
import colors from '@core/utils/colors';

export default colors(vars);
